import {
	applySystemBackupFilter,
	focusSystemBackup,
	openSystemBackupSection,
} from './adapter';
import {
	openSystemBackupCreateModal,
	openSystemBackupDeleteModal,
	openSystemBackupRestoreModal,
	openSystemBackupUploadModal,
} from './modal';
import {mapSystemBackupPrefill} from './prefill';
import {resolveSystemBackups} from './resolver';
import {serializeSystemBackupContext} from './context';

/**
 * System Backup.
 *
 * One of two lists on the Backup tab - the other is Site Backup, a
 * different resource with its own API, columns, and permission
 * (`cnmssystembackuprestore`, gating the accordion itself, not just its
 * actions). `edit` is declared so the capability exists to answer "can I
 * edit a backup" with a canned no, but carries no modal.
 */
const systemBackupPlugin = {
	id: 'system_backup',
	version: 1,
	commandVersion: 1,
	resource: 'system_backup',
	operations: [
		'options',
		'view',
		'search',
		'create',
		'upload',
		'download',
		'restore',
		'delete',
		'bulk_delete',
		'refresh',
		'edit',
	],
	dependencies: {
		plugins: ['canvas.navigation', 'backup'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.system_backup': openSystemBackupSection,
	},
	resolvers: {
		system_backup: resolveSystemBackups,
	},
	filters: {
		system_backup: applySystemBackupFilter,
	},
	focusHandlers: {
		system_backup: focusSystemBackup,
	},
	modals: {
		'system_backup.create': openSystemBackupCreateModal,
		'system_backup.upload': openSystemBackupUploadModal,
		'system_backup.restore': openSystemBackupRestoreModal,
		'system_backup.delete': openSystemBackupDeleteModal,
	},
	prefillMappers: {
		'system_backup.create': mapSystemBackupPrefill,
	},
	contextSerializers: {
		system_backup: serializeSystemBackupContext,
	},
};

export default systemBackupPlugin;
